import React from 'react';

const PromoBanner = ({ onClose }) => {
  const demoClassLink = 'https://docs.google.com/forms/d/e/1FAIpQLSd2GIm6D1KVxc6JS0fqnORGUaMqekIFCYzclq9dqucud-cd9g/viewform?usp=sf_link'; // Replace with your actual demo class link
  const webinarLink = 'https://meet.google.com/mrf-nhsx-hgp'; // Replace with your actual webinar link

  return (
    <div
      className="fixed top-0 w-full bg-gradient-to-r from-pink-500 to-orange-500 text-white flex justify-center items-center p-2 text-center z-[1000]"
      style={{ height: 'auto', minHeight: '60px' }} // Adjusted for mobile
    >
      <div className="flex flex-col md:flex-row items-center justify-center w-full max-w-screen-xl">
        {/* <p className="font-bold text-sm md:text-base lg:text-lg text-center md:text-left flex-1 md:flex-initial md:mr-3">
           <span className="font-extrabold front-bounce">Join Our Waitlist</span>
        </p> */}
        <div className="flex items-center space-x-2 md:space-x-4 lg:space-x-6 md:mt-0">
          <a  
            href='/contact'    
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-black font-semibold py-1 px-3 rounded-lg transition duration-300 hover:bg-theme-green hover:text-white text-xs md:text-sm lg:text-base front-bounce"
            aria-label="Join Free Demo Class"
          >
            Unlock Early Access - <span className='text-theme-orange' >Secure Your Place Today!</span>
          </a>
          
          {/* <button
            onClick={onClose}
            className="text-white focus:outline-none text-lg md:text-xl lg:text-2xl"
            aria-label="Close banner"
          >
            ✕
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
